module.exports = __webpack_public_path__ + "img/logo-color-horizontal.1db96e3f.svg";